// Import translations
import * as dictionary from 'translations/dictionary';

export const langResources = Object.entries(dictionary).reduce((acc, next) => {
	const [key, translation] = next;
	acc[key] = { translation };
	return acc;
}, {});

export const pathnameLngDetector = {
	name: 'pathname',
	lookup({ supported = [] }) {
		const { pathname } = window.location;
		const lng = pathname.split('/')[1];
		const isSupported = supported.includes(lng);
		return isSupported ? lng : undefined;
	}
};
